import { render, staticRenderFns } from "./drag-scroll-wrapper.vue?vue&type=template&id=1a1b9b50"
import script from "./drag-scroll-wrapper.vue?vue&type=script&lang=js"
export * from "./drag-scroll-wrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/binhdoan/Work/Dev-gits/Shopify-KL/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a1b9b50')) {
      api.createRecord('1a1b9b50', component.options)
    } else {
      api.reload('1a1b9b50', component.options)
    }
    module.hot.accept("./drag-scroll-wrapper.vue?vue&type=template&id=1a1b9b50", function () {
      api.rerender('1a1b9b50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/drag-scroll-wrapper.vue"
export default component.exports